/**
 * 地図タイプ（地図 / 航空写真）の選択を localStorage に永続化するフック
 */

import { useCallback, useState } from 'react'

export type MapTypeId = 'roadmap' | 'hybrid'

const STORAGE_KEY = 'pml:map-type-id'

const isMapTypeId = (value: string | null): value is MapTypeId => value === 'roadmap' || value === 'hybrid'

export function useMapType(fallback: MapTypeId): [MapTypeId, (value: MapTypeId) => void] {
  const [mapTypeId, setMapTypeId] = useState<MapTypeId>(() => {
    const stored = localStorage.getItem(STORAGE_KEY)
    return isMapTypeId(stored) ? stored : fallback
  })

  const update = useCallback((value: MapTypeId) => {
    setMapTypeId(value)
    localStorage.setItem(STORAGE_KEY, value)
  }, [])

  return [mapTypeId, update]
}
